/*eslint-disable*/

import React, { useState } from "react";
import styled from "styled-components";
import Tick from "../assets/Icons/tick-circle.svg";
import ArrowLeft from "../assets/Icons/arrow-left.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";

import PaymentService from "../Services/PaymentService";
import GeneralDataServices from "../Services/GeneralDataServices";
import toast from "react-hot-toast";

const CURRENCY_SYMBOLS = {
  NGN: "₦",
  USD: "$",
  GBP: "£",
  EUR: "€",
  ZAR: "R",
  KES: "KSh",
  GHS: "GH₵",
};

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #fffffa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Body = styled.div`
  width: 45%;
  min-height: 50%;
  box-shadow: 0px 0px 65px 21px #0000000a;
  border-radius: 20px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;

  @media (max-width: 1040px) {
    width: 95%;
    min-height: 70%;
  }
`;

const SponsorStatus = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  let learner = searchParams.get("learner");
  let learner_id = searchParams.get("id");
  let price = searchParams.get("price");
  let state = searchParams.get("state");
  let unit = searchParams.get("unit");
  let requestID = searchParams.get("requestID");
  let meet = searchParams.get("meet");
  let email = searchParams.get("email");

  if (state === "meet") {
    return (
      <MeetLearner
        learner={learner}
        name={learner}
        id={learner_id}
        price={price}
        unit={unit}
        requestID={requestID}
        email={email}
      />
    );
  } else {
    return (
      <PayCourse
        learner={learner}
        id={learner_id}
        price={price}
        unit={unit}
        loading={loading}
        setLoading={setLoading}
        requestID={requestID}
        meet={meet}
        email={email}
      />
    );
  }
};

const MeetLearner = ({ learner, name, id, price, unit, requestID, email }) => {
  const router = useNavigate();
  const [scheduled, setScheduled] = useState(false);

  const handleSchedule = async () => {
    const title = encodeURIComponent(`Motivar - Sponsor Meetup with ${name || learner}`);
    const details = encodeURIComponent(
      `Hello, ${name || learner}. We will be meeting to discuss your interest in the course sponsorship you requested on Motivar!. Please do well to be available within the set time. Thanks!`
    );
    const invitee = encodeURIComponent(email || "");
    const url = `https://calendar.google.com/calendar/u/0/r/eventedit?text=${title}&details=${details}&add=${invitee}&conference=hangouts`;
    window.open(url, "_blank");
    setScheduled(true);
    toast.success("Meeting scheduler opened!");

    try {
      await GeneralDataServices.notifyMeetingSchedule({
        name: name || learner,
        id,
        price,
        unit,
        email,
        requestId: requestID,
      });
    } catch (err) {
      console.error("Failed to notify meeting schedule:", err);
    }
  };

  return (
    <Wrapper>
      <Body>
        <img
          src={Tick}
          style={{
            objectFit: "center",
            height: "70px",
            width: "70px",
          }}
          alt="tick"
        />
        <p
          style={{
            fontWeight: "bolder",
            fontSize: "22px",
            padding: "20px 0px 5px 0px",
            margin: 0,
          }}
        >
          {scheduled ? "Meeting Link Opened!" : "Payment Complete — Schedule Meeting"}
        </p>
        <p
          style={{
            width: "80%",
            fontSize: "15px",
            textAlign: "center",
            color: "#64748b",
            margin: "10px 0 25px",
          }}
        >
          {scheduled
            ? `Your virtual meeting link for ${learner} has been opened in a new tab.`
            : `Your sponsorship payment for ${learner} was successful! Tap below to schedule your virtual meeting.`}
        </p>

        <Button
          onClick={handleSchedule}
          style={{
            backgroundColor: "#00AA87",
            border: "none",
            width: "60%",
            fontSize: "17px",
            fontWeight: "bold",
            borderRadius: "10px",
            padding: "10px",
            marginBottom: "12px",
          }}
        >
          {scheduled ? "Re-open Meeting Link" : "📅 Schedule Virtual Meeting"}
        </Button>

        <Button
          variant="light"
          onClick={() => router("/dashboard")}
          style={{
            width: "60%",
            fontSize: "15px",
            fontWeight: "600",
            borderRadius: "10px",
            padding: "8px",
          }}
        >
          Go to Dashboard
        </Button>

        <p
          onClick={() => {
            router("/help-learner");
          }}
          style={{
            width: "80%",
            margin: "2vh auto 2vh auto",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <img
            src={ArrowLeft}
            style={{
              objectFit: "center",
              height: "20px",
              width: "30px",
            }}
            alt="back"
          />
          <div>
            <h6
              style={{
                color: "#00AA87",
                fontSize: "16px",
                padding: "10px",
                margin: 0,
              }}
            >
              Go back to Listing
            </h6>
          </div>
        </p>
      </Body>
    </Wrapper>
  );
};

const PayCourse = ({
  learner,
  id,
  price,
  unit,
  loading,
  setLoading,
  requestID,
  meet,
  email,
}) => {
  const router = useNavigate();

  const handlePayWithPaystack = async () => {
    const amountValue = Number(price);
    if (!Number.isFinite(amountValue) || amountValue <= 0) {
      toast.error("Invalid sponsorship amount.");
      return;
    }

    setLoading(true);
    const paymentWindow = window.open("", "_blank");
    try {
      const payload = {
        amount: Math.round(amountValue * 100),
        requestID: requestID,
        currency: unit,
        description: `Sponsoring ${learner} for a ${unit}${amountValue.toLocaleString(
          "en-US",
          {
            minimumFractionDigits: 0,
          }
        )} course.`,
      };
      const resp = await PaymentService.InitiatePayment(payload);
      setLoading(false);

      const paystackRef = resp?.data?.data?.data?.reference;
      if (paystackRef) {
        localStorage.setItem(`requestID-${paystackRef}`, requestID);
        if (meet === "true") {
          localStorage.setItem(
            `meetLearner-${paystackRef}`,
            JSON.stringify({
              email,
              name: learner,
              id,
              price,
              unit,
              requestId: requestID,
            })
          );
        }
      }

      const authUrl = resp.data.data.data.authorization_url;
      if (paymentWindow) {
        paymentWindow.location = authUrl;
      } else {
        window.open(authUrl, "_blank");
      }
    } catch (error) {
      setLoading(false);
      if (paymentWindow) paymentWindow.close();
      toast.error(
        error?.response?.data?.message || "Error initiating payment.."
      );
      console.log("Error initiating payment..", error);
    }
  };

  return (
    <Wrapper>
      <Body>
        <img
          src={Tick}
          style={{
            objectFit: "center",
            height: "70px",
            width: "70px",
          }}
          alt="tick"
        />
        <p
          style={{
            fontWeight: "bolder",
            fontSize: "20px",
            padding: "20px 0px 5px 0px",
          }}
        >
          Complete Your Sponsorship
        </p>
        <p
          style={{
            width: "70%",
            fontSize: "16px",
            textAlign: "center",
          }}
        >
          Now complete your
          <br />{" "}
          <b>
            {CURRENCY_SYMBOLS[unit] || ""}
            {Number(price).toLocaleString("en-US", {
              minimumFractionDigits: 0,
            })}
          </b>{" "}
          sponsorship for <b>{learner}</b>
        </p>

        {meet === "true" && (
          <p style={{ fontSize: "13px", color: "#00AA87", fontWeight: "600", marginBottom: "15px" }}>
            📅 You can schedule your virtual meeting immediately after payment.
          </p>
        )}

        <Button
          onClick={() => handlePayWithPaystack()}
          style={{
            backgroundColor: "#00AA87",
            border: "none",
            width: "50%",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          {loading && <Spinner animation="border" role="status" />}
          {!loading && "Pay for course"}
        </Button>

        <p
          onClick={() => {
            router("/help-learner");
          }}
          style={{
            width: "80%",
            margin: "2vh auto 2vh auto",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <img
            src={ArrowLeft}
            style={{
              objectFit: "center",
              height: "20px",
              width: "30px",
            }}
            alt="back"
          />
          <div>
            <h6
              style={{
                color: "#00AA87",
                fontSize: "16px",
                padding: "10px",
                margin: 0,
              }}
            >
              Go back to Listing
            </h6>
          </div>
        </p>
      </Body>
    </Wrapper>
  );
};

export default SponsorStatus;
